import { Link } from "react-router-dom";
import {
  FaUser,
  FaRegCalendarAlt,
  FaTag,
  FaStar,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import SearchBox from "./SearchBox";

const BlogDetailsSection = ({ post }) => {
  if (!post) return <p>Post not found.</p>;

  return (
    <section className="news-details-section section-padding">
      <div className="container">
        <div className="news-details-area">
          <div className="row g-4">
            {/* Main Content */}
            <div className="col-12 col-lg-8">
              <div className="blog-post-details">
                <div className="single-blog-post">
                  {post.image && (
                    <div
                      className="post-featured-thumb bg-cover"
                      style={{ backgroundImage: `url(${post.image})` }}
                    ></div>
                  )}

                  <div className="post-content">
                    <ul className="post-list d-flex align-items-center">
                      <li>
                        <FaUser /> By {post.author}
                      </li>
                      <li>
                        <FaRegCalendarAlt /> {post.date}
                      </li>
                      <li>
                        <FaTag /> {post.category}
                      </li>
                    </ul>

                    <h3>{post.title}</h3>

                    {post.content.map((block, i) => {
                      if (block.type === "highlight") {
                        return (
                          <div
                            key={i}
                            className="hilight-text mt-4 mb-4"
                          >
                            <p>{block.value}</p>
                          </div>
                        );
                      }

                      if (block.type === "list") {
                        return (
                          <ul
                            key={i}
                            className="blog-list mb-3"
                          >
                            {block.value.map((item, idx) => (
                              <li key={idx}>{item}</li>
                            ))}
                          </ul>
                        );
                      }

                      return (
                        <p
                          key={i}
                          className="mb-3"
                        >
                          {block.value}
                        </p>
                      );
                    })}

                    {post.images && (
                      <div className="row g-4">
                        {post.images.map((img, i) => (
                          <div
                            className="col-lg-6"
                            key={i}
                          >
                            <div className="details-image">
                              <img
                                src={img}
                                alt={`blog-img-${i}`}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    <p className="pt-5">
                      {post.contentExtra
                        ? post.contentExtra
                        : "No extra content provided."}
                    </p>

                    {/* Tags + Social */}
                    <div className="row tag-share-wrap mt-4 mb-5">
                      <div className="col-lg-8 col-12">
                        <div className="tagcloud">
                          <span>Tags: </span>
                          {post.tags.map((tag, i) => (
                            <Link
                              key={i}
                              to="#"
                            >
                              {tag}
                            </Link>
                          ))}
                        </div>
                      </div>
                      <div className="col-lg-4 col-12 mt-3 mt-lg-0 text-lg-end">
                        <div className="social-share">
                          <span className="me-3">Share:</span>
                          <a
                            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                              window.location.href
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaFacebookF />
                          </a>
                          <a
                            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                              window.location.href
                            )}&text=${encodeURIComponent(post.title)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaTwitter />
                          </a>
                          {/* LinkedIn */}
                          <a
                            href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                              window.location.href
                            )}&title=${encodeURIComponent(post.title)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaLinkedinIn />
                          </a>
                          <Link to="#">
                            <FaYoutube />
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* Comments */}
                    <div className="comments-area">
                      <div className="comments-heading">
                        <h3>
                          {post.comments.length < 10
                            ? `0${post.comments.length} Comments`
                            : `${post.comments.length} Comments`}
                        </h3>
                      </div>

                      {post.comments.map((c, i) => (
                        <div
                          className={`blog-single-comment d-flex gap-4 ${
                            i === 0 ? "pt-4 pb-5" : "pt-5 pb-5"
                          }`}
                          key={i}
                        >
                          <div className="image">
                            <img
                              className=" rounded"
                              src={c.avatar}
                              alt={c.name}
                            />
                          </div>
                          <div className="content">
                            <div className="head d-flex flex-wrap gap-2 align-items-center justify-content-between">
                              <div className="con">
                                <h5>
                                  <Link to="#">{c.name}</Link>
                                </h5>
                                <span>{c.date}</span>
                              </div>
                              <div className="star">
                                {Array.from({ length: c.rating }).map(
                                  (_, idx) => (
                                    <FaStar key={idx} />
                                  )
                                )}
                              </div>
                            </div>
                            <p className="mt-30 mb-4">{c.message}</p>
                            {/* <Link
                              to="#"
                              className="reply"
                            >
                              Reply
                            </Link> */}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="main-sidebar">
                {/* Search */}
                <SearchBox />

                {/* Top Category */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Top Danh Mục</h3>
                  </div>
                  <div className="news-widget-categories">
                    <ul>
                      {post.sidebar.categories.map((cat, i) => (
                        <li
                          key={i}
                          className={cat.active ? "active" : ""}
                        >
                          <Link to="#">{cat.name}</Link>
                          <span>({cat.count})</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Recent Posts */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Bài Viết Nổi Bật</h3>
                  </div>
                  <div className="recent-post-area">
                    {post.sidebar.recentPosts.map((r, i) => (
                      <div
                        className="recent-items"
                        key={i}
                      >
                        <div className="recent-thumb">
                          <img
                            src={r.image}
                            alt={r.title}
                          />
                        </div>
                        <div className="recent-content">
                          <span>{r.category}</span>
                          <ul>
                            <li>
                              <i className="fa-regular fa-calendar-days"></i>{" "}
                              {r.date}
                            </li>
                          </ul>
                          <h6>
                            <Link to={`/bai-viet/${r.slug}`}>{r.title}</Link>
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Tags */}
                <div className="single-sidebar-widget">
                  <div className="wid-title">
                    <h3>Tags Phổ Biến</h3>
                  </div>
                  <div className="tagcloud">
                    {post.sidebar.tags.map((tag, i) => (
                      <Link
                        key={i}
                        to="#"
                      >
                        {tag}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsSection;
